import {create} from 'zustand';
import {CustomTreatmentDataType} from '../../types';
import {UseTreatmentDataStoreProps} from './types';

export const useTreatmentDataStore = create<UseTreatmentDataStoreProps>(set => ({
	data: {} as CustomTreatmentDataType,
	setData: data => set({data}),
	resetData: () => set({data: {} as CustomTreatmentDataType}),
}));
